import { render } from "./StreamView.vue?vue&type=template&id=47394cfc"
import script from "./StreamView.vue?vue&type=script&lang=js"
export * from "./StreamView.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__